module.exports = __webpack_public_path__ + "img/frame (94).68cc8dec.jpg";